import Fetch from '@common-libs/utils/fetch'
import apiMonitorHelper from '@lib/business/apiMonitorHelper.js'

export default new Fetch({
  resHandle: (res, options) => {
    const errorNo = res.errorCode
    if (errorNo === 0) {
      return Promise.resolve(res.content)
    } else {
      apiMonitorHelper.apiMonitor(options.url, res, errorNo)
      // eslint-disable-next-line prefer-promise-reject-errors
      return Promise.reject({ errorNo, errorMsg: res.errorMessage })
    }
  }
})
